module.exports = __webpack_public_path__ + "img/edutech.f69ef972.png";